<template>
    
  <div class="container">
    <div class="container_box">
      <div class="messageBox">
        <el-autocomplete
          class="inline-input"
          v-model="information"
          :fetch-suggestions="querySearch"
          placeholder="请输入关键字，点击搜索按钮进行搜索..."
          :trigger-on-focus="false"
          @select="handleSelect"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            type="goon"
            @click="search"
          ></el-button>
        </el-autocomplete>
      </div>
      <div class="centerMessage">
        <span>常见问题（{{ allCount }}）</span>
      </div>
      <div class="bottomBox">
        <div class="questionbox" v-for="item in commonQuestion" :key="item.id">
          <div class="itemTop">
            <div class="leftContent">
              <img src="@/img/commIcon.png" alt="" />
              <div class="textbox">
                <span> {{ item.question }}</span>
              </div>
            </div>
            <div class="right_content">
              <span>{{ item.created_at }}</span>
              <img
                :src="
                  item.leftSelect_icon
                    ? item.leftIcon_select
                    : item.leftIcon_default
                "
                alt=""
                width="25px"
                @click="changeLeftIcon(item.id)"
              />
            </div>
          </div>

          <div
            class="itemBottom"
            :style="
              item.isShowAnswer ? { display: 'block' } : { display: 'none' }
            "
          >
            <div class="bottomIcon">
              <div><img src="@/img/commIconMess.png" alt="" /></div>
            </div>
            <div class="textbox">
              <span>{{ item.answer }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <paginationChange :pageData="pageData" @chagePage="chagePage" />
  </div>
</template>

<script>
import paginationChange from '../../common/paginationChange.vue'
import { questionList } from '@/api/experiment/index'
export default {
  name: '',
  components: { paginationChange },
  props: [],
  data() {
    return {
      information: '',
      allCount: 0,
      inputTipList: [],
      questionAnswer: {},
      tipList: [],
      pageData: {
        total: 24,
        pageSize: 4,
        page: 1,
      },
      changeHeight: 0,
      commonQuestion: [],
      restaurants: [],
      state1: '',
      state2: '',
      timer: null,
    }
  },
  watch: {},
  computed: {},
  created() {
    this.loadListdata()
  },
  mounted() {
    this.restaurants = this.loadAll()
  },
  methods: {
    changeLeftIcon(id) {
      for (let i = 0; i < this.commonQuestion.length; i++) {
        if (id === this.commonQuestion[i].id) {
          this.commonQuestion[i].leftSelect_icon =
            !this.commonQuestion[i].leftSelect_icon
          this.commonQuestion[i].isShowAnswer =
            !this.commonQuestion[i].isShowAnswer
        } else {
          this.commonQuestion[i].leftSelect_icon = false
          this.commonQuestion[i].isShowAnswer = false
        }
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    loadListdata() {
      var that = this
      questionList({
        course_id: window.localStorage.getItem('expId'),
        problem_type: 2,
        limit: 4,
        page: that.pageData.page,
      }).then((res) => {
        const { data } = res.data
        for (let i = 0; i < data.length; i++) {
          data[i].leftSelect_icon = false
          data[i].leftIcon_default = require('@/img/select_Icon_up.png')
          data[i].leftIcon_select = require('@/img/select_Icon_down.png')
        }
        this.commonQuestion = data
        this.allCount = res.data.total
        that.pageData.total = res.data.total
        that.pageData.pageSize = res.data.per_page
      })
    },
    chagePage(e) {
      this.pageData.page = e
      this.loadListdata()
    },
    search() {
      if (!this.information) {
        this.$notify({
          type: 'error',
          message: '请输入关键字!',
          duration: 1500,
          title: '搜索失败',
        })
      }
      var that = this
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        questionList({
          course_id: window.localStorage.getItem('expId'),
          question: this.information,
          problem_type: 2,
          limit: 4,
          page: that.pageData.page,
        }).then((res) => {
          const { data } = res.data
          for (let i = 0; i < data.length; i++) {
            data[i].leftSelect_icon = false
            data[i].leftIcon_default = require('@/img/select_Icon_up.png')
            data[i].leftIcon_select = require('@/img/select_Icon_down.png')
            data[i].isShowAnswer = false
          }
          that.commonQuestion = data
          that.inputTipList = data
          that.allCount = res.data.total
          that.pageData.total = res.data.total
          that.pageData.pageSize = res.data.per_page
        })
      }, 200)
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      cb(results)
    },
    loadAll() {
      var that = this
      questionList({
        course_id: window.localStorage.getItem('expId'),
        problem_type: 2,
      }).then((res) => {
        const { data } = res.data
        for (let i = 0; i < data.length; i++) {
          ;(function (i) {
            var tipObj = {}
            tipObj.value = data[i].question
            that.tipList.push(tipObj)
          })(i)
        }
      })
      return this.tipList
    },
    handleSelect(item) {
      // console.log(item)
    },
  },
}
</script>

<style lang="scss">
.container  {
  width: 100%;
}
.questionbox {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: height 0.3s;
  .itemTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #edf2f6;
    .textbox {
      margin-left: 10px;
      // width: 500px;
      span {
        font-size: 18px;
        color: #666666;
        font-weight: bold;
      }
    }
    .leftContent {
      display: flex;
      align-items: center;
    }
    .right_content {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      img {
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .itemBottom {
    padding: 20px 20px;
    .bottomIcon {
      display: inline-block;
    }
    .textbox {
      width: 90%;
      margin-left: 15px;
      display: inline-block;
      vertical-align: top;
      span {
        font-size: 16px;
        color: #666666;
      }
    }
  }
}
.bottomBox {
  padding: 0 20px;
}
.messageBox {
  padding: 18px 20px 18px 20px;
}
.centerMessage {
  font-size: 18px;
  font-weight: bold;
  color: #0c5893;
  padding: 0px 0px 20px 20px;
}
.container_box {
  padding-bottom: 20px;
}

.el-button {
  width: 110px;
  padding: 10px 10px 8px 10px;
  border: none;
  border-radius: 0;
  background-color: #0c5893 !important;
}
.el-icon-search {
  font-size: 25px;
  color: white;
}
.el-autocomplete {
  overflow: hidden;
  width: 100%;
}

.isShow {
  display: block;
}
.dontShow {
  display: none;
}
</style>